module.exports = __webpack_public_path__ + "static/media/Gøyme.6e1c419b.m4a";